import { Journeys, Targets } from '@atlassiansox/cross-flow-support';

import { type AppRecommendation } from '../types';

export type Journey = (typeof Journeys)[keyof typeof Journeys];
const DEFAULT_RECOMMENDATION_JOURNEY = Journeys.DECIDE;
const TARGET_LOOM = Targets.LOOM || 'loom'; // adminHub Targets.LOOM is not defined

export const getJourney = (app: AppRecommendation): Journey => {
	// TODO - Investigate whether Jira should use the GET_STARTED journey

	if (app.hamsIdentifier === Targets.CONFLUENCE) {
		return Journeys.GET_STARTED;
	}

	if (app.hamsIdentifier === Targets.JIRA_SERVICE_DESK) {
		return Journeys.GET_STARTED;
	}

	if (app.hamsIdentifier === Targets.JIRA_PRODUCT_DISCOVERY) {
		return Journeys.GET_STARTED;
	}

	if (app.hamsIdentifier === TARGET_LOOM) {
		return Journeys.GET_STARTED;
	}

	return DEFAULT_RECOMMENDATION_JOURNEY;
};
